import { memo } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import { selectIsLogged } from '@betty/auth/state';
import { selectHasUserDeposited } from '@betty/wallet/state';
import { useSelector } from '@betty/toolkit/state';
import { OnboardingHeader } from '@betty/onboarding';

import MainHeader from './MainHeader/MainHeader';
import RouteHeader from './RouteHeader/RouteHeader';
import {
  MainHeaderDisabledRoutes,
  RouteHeaderDisabledRoutes,
} from './Header.constants';
import styles from './Header.module.css';
import AuthHeader from './AuthHeader/AuthHeader';

function Header() {
  const location = useLocation();
  const isLoggedIn = useSelector(selectIsLogged);
  const hasUserDeposited = useSelector(selectHasUserDeposited);
  const mainHeaderDisabled = matchRoutes(MainHeaderDisabledRoutes, location);
  const routeHeaderDisabled = matchRoutes(RouteHeaderDisabledRoutes, location);

  const renderHeader = () => {
    if (!isLoggedIn) {
      return <AuthHeader />;
    }

    if (!hasUserDeposited) {
      return <OnboardingHeader />;
    }

    return <MainHeader />;
  };

  if (mainHeaderDisabled && routeHeaderDisabled) {
    return null;
  }

  return (
    <header className={styles.header}>
      {mainHeaderDisabled ? null : renderHeader()}
      {routeHeaderDisabled ? null : <RouteHeader />}
    </header>
  );
}

export default memo(Header);
